import { playAudio, stopAudio, AUDIO_TOUR, AUDIO_STOP } from 'aria-viewer/audiomanager/audioManagerActions'

export const LANGUAGE_CHANGE = '|A|LANGUAGE_CHANGE'

export const setLanguage = newLanguage => {
    return {
        type: LANGUAGE_CHANGE,
        language: newLanguage,
    }
}

export const changeLanguage = newLanguage => {
    return (dispatch, getState) => {
        dispatch(setLanguage(newLanguage))
        const state = getState()
        if (state.getIn(['audioManager', 'state', AUDIO_TOUR]) != AUDIO_STOP) {
            if (newLanguage.language) {
                dispatch(playAudio(AUDIO_TOUR))
            } else {
                dispatch(stopAudio(AUDIO_TOUR))
            }
        }
    }
}
